(function () {
  var storageKey = 'hole-favorites';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(storageKey));
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(storageKey, JSON.stringify(list));
  }

  function sync(button) {
    var saved = read().some(function (item) {
      return String(item.id) === String(button.dataset.productId);
    });
    var nextPressed = saved ? 'true' : 'false';
    if (button.getAttribute('aria-pressed') !== nextPressed) {
      button.setAttribute('aria-pressed', nextPressed);
    }
    if (!button.classList.contains('product__favorite') && button.classList.contains('button--filled') !== saved) {
      button.classList.toggle('button--filled', saved);
      button.classList.toggle('button--outlined', !saved);
    }
    var label = button.querySelector('[data-label]');
    var nextLabel = saved ? button.dataset.addedLabel : button.dataset.addLabel;
    if (label && label.textContent !== nextLabel) {
      label.textContent = nextLabel;
    }
    if (nextLabel && button.hasAttribute('aria-label') && button.getAttribute('aria-label') !== nextLabel) {
      button.setAttribute('aria-label', nextLabel);
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-hole-favorite]').forEach(sync);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hole-favorite]');
    if (!button) return;
    event.preventDefault();
    var id = String(button.dataset.productId);
    var list = read();
    var exists = list.some(function (item) {
      return String(item.id) === id;
    });
    if (exists) {
      list = list.filter(function (item) {
        return String(item.id) !== id;
      });
    } else {
      list.push({
        id: id,
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle
      });
    }
    write(list);
    sync(button);
  });

  function watch() {
    var root = document.querySelector('product-info');
    if (!root || root.dataset.holeFavoriteBound) return;
    root.dataset.holeFavoriteBound = 'true';
    new MutationObserver(syncAll).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watch();
      syncAll();
    });
  } else {
    watch();
    syncAll();
  }
})();
